import {
  isEndOfDay,
  isNumber,
  isStartOfDay,
  padNumber,
  toInteger,
} from '@shared/utils';

export class NgbTime {
  hour: number;
  minute: number;
  second: number;

  constructor(hour?: number, minute?: number, second?: number) {
    this.hour = toInteger(hour);
    this.minute = toInteger(minute);
    this.second = toInteger(second);
  }

  changeHour(step = 1): void {
    if (step === 0) {
      return;
    }

    if (isNaN(this.hour)) {
      this.updateHour(0);
    } else if (isEndOfDay(this)) {
      this.updateHour(24 + step);
    } else if (isStartOfDay(this) && step < 0) {
      this.updateHour(0 + step);
    } else {
      this.updateHour(this.hour + step);
    }
    // this.updateHour((isNaN(this.hour) ? 0 : this.hour) + step);    // original code
  }

  updateHour(hour: number): void {
    if (isNumber(hour)) {
      // custom code begin
      if (hour === 24) {
        this.hour = 23;
        this.minute = 59;
        this.second = 59;
      } else {
        if (isEndOfDay(this)) {
          this.minute = 0;
          this.second = 0;
          if (hour > 24) {
            this.hour = 0;
            return;
          }
        }
        if (isStartOfDay(this) && hour < 0) {
          this.hour = 23;
          this.minute = 59;
          this.second = 59;
          return;
        }
        // custom code end
        this.hour = (hour < 0 ? 24 + hour : hour) % 24;
      }
    } else {
      this.hour = NaN;
    }
  }

  changeMinute(step = 1): void {
    if (step === 0) {
      return;
    }

    if (isNaN(this.minute)) {
      this.updateMinute(0);
    } else if (isEndOfDay(this) && step > 0) {
      this.updateMinute(Number.MAX_VALUE);
    } else if (isEndOfDay(this) && step < 0) {
      this.updateMinute(Number.MIN_VALUE);
    } else {
      this.updateMinute(this.minute + step);
    }
    // this.updateMinute((isNaN(this.minute) ? 0 : this.minute) + step);     // original code
  }

  updateMinute(minute: number): void {
    if (isNumber(minute)) {
      // custom code begin
      if (isEndOfDay(this)) {
        if (minute === Number.MAX_VALUE) {
          this.hour = 0;
          this.minute = 0;
          this.second = 0;
          return;
        }
        if (minute === Number.MIN_VALUE) {
          this.hour = 23;
          this.minute = 59;
          this.second = 0;
          return;
        }
      }
      if (isStartOfDay(this) && minute < 0) {
        this.hour = 23;
        this.minute = 59;
        this.second = 59;
        return;
      }
      // custom code end
      this.minute = minute % 60 < 0 ? 60 + (minute % 60) : minute % 60;
      this.second = 0; // custom code
      this.changeHour(Math.floor(minute / 60));
    } else {
      this.minute = NaN;
    }
  }

  changeSecond(step = 1): void {
    this.updateSecond((isNaN(this.second) ? 0 : this.second) + step);
  }

  updateSecond(second: number): void {
    if (isNumber(second)) {
      this.second = second < 0 ? 60 + (second % 60) : second % 60;
      this.changeMinute(Math.floor(second / 60));
    } else {
      this.second = NaN;
    }
  }

  isValid(checkSecs = true): boolean {
    return (
      isNumber(this.hour) &&
      isNumber(this.minute) &&
      (checkSecs ? isNumber(this.second) : true)
    );
  }

  toString(): string {
    return `${padNumber(this.hour || 0)}:${padNumber(
      this.minute || 0
    )}:${padNumber(this.second || 0)}`;
  }
}
